import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../lib/api';

export function useAuditLog({
  page = 1,
  perPage = 20,
  action,
}: {
  page?: number;
  perPage?: number;
  action?: string;
} = {}) {
  return useQuery({
    queryKey: ['audit-log', page, perPage, action],
    queryFn: () => adminApi.auditLog.list({ page, per_page: perPage, action: action || undefined }),
  });
}
